import { h } from 'preact';
import BaseItem from './BaseItem';

export default function render({ items, classname, isVisible }) {

  items = Array.isArray(items) ? items : [];
  items = items.sort(compareFunction).map(BaseItem);

  return h(
    'ul',
    { "class": ((classname || "fab-buttons") + " " + (isVisible ? "" : "hide")) },
    items
  );
}

function compareFunction(action1, action2) {
  return action1.order < action2.order ? 1 : -1;
}
